import i from "../../node_modules/.pnpm/@heroicons_vue@2.0.13_vue@3.3.4/node_modules/@heroicons/vue/20/solid/esm/CheckCircleIcon.mjs";
import s from "../../node_modules/.pnpm/@heroicons_vue@2.0.13_vue@3.3.4/node_modules/@heroicons/vue/20/solid/esm/ExclamationCircleIcon.mjs";
import n from "../../node_modules/.pnpm/@heroicons_vue@2.0.13_vue@3.3.4/node_modules/@heroicons/vue/20/solid/esm/ExclamationTriangleIcon.mjs";
import l from "../../node_modules/.pnpm/@heroicons_vue@2.0.13_vue@3.3.4/node_modules/@heroicons/vue/20/solid/esm/InformationCircleIcon.mjs";
import { defineComponent as p, h as o } from "vue";
import r from "./Notification.vue.mjs";
const a = {
  success: {
    progressColor: "green",
    icon: i,
    iconClass: "text-green-500"
  },
  info: {
    progressColor: "indigo",
    icon: l,
    iconClass: "text-indigo-500"
  },
  warning: {
    progressColor: "orange",
    icon: n,
    iconClass: "text-orange-500"
  },
  error: {
    progressColor: "red",
    icon: s,
    iconClass: "text-red-500"
  }
}, g = p({
  name: "TuiFlashNotification",
  components: { TuiNotification: r },
  props: {
    type: {
      type: String,
      required: !0
    },
    show: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: void 0
    },
    closeDelay: {
      type: [String, Number],
      default: 2500
    },
    disableTeleport: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:show", "hidden"],
  render() {
    const e = a[this.type];
    return o(
      r,
      {
        show: this.show,
        "onUpdate:show": (t) => this.$emit("update:show", t),
        onHidden: () => this.$emit("hidden"),
        title: this.title,
        description: this.description,
        closeDelay: this.closeDelay,
        autoClose: !0,
        progressColor: e.progressColor,
        disableTeleport: this.disableTeleport
      },
      {
        icon: () => o(e.icon, { class: ["size-5", e.iconClass] })
      }
    );
  }
});
export {
  g as default
};
//# sourceMappingURL=FlashNotification.vue.mjs.map
